import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import React from 'react';
import { AssessmentsMobileHeader } from './AssessmentsMobileHeader';
import { AssessmentsDesktopHeader } from './AssessmentsDesktopHeader';
import { AssessmentsHeaderProps } from './types';

export const AssessmentsHeader = (props: AssessmentsHeaderProps) => {
  const { isMobile } = useDeviceType();

  if (isMobile) {
    return <AssessmentsMobileHeader {...props} />;
  }

  return <AssessmentsDesktopHeader {...props} />;
};
